import TopHeader from "../../components/TopHeader.tsx";
import "./OrderHistoryLog.css";
import gross from "../../assets/icons/gross.png";
import credit from "../../assets/icons/credit.png";
import leftSidebarArrow from "../../assets/icons/leftSidebarArrow.png";
import service from "../../assets/icons/global.png";
import tip from "../../assets/icons/tips.png";
import mobilePayment from "../../assets/icons/mobile-payment.png";
import bill from "../../assets/icons/bill.png";
import refund from "../../assets/icons/money.png";
import React, { useEffect, useState } from "react";
import AmountCard from "../components/AmountCard/AmountCard.tsx";
import axios from "axios";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableContainer from "@mui/material/TableContainer";
import Paper from "@mui/material/Paper";
import OrderRow from "./OrderRow.tsx";
import Button from "@mui/material/Button";
import {
  Box,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  FormControl,
  Grid,
  InputLabel,
  MenuItem,
  Select,
  TableCell,
  TableRow,
  Typography,
} from "@mui/material";
import closeIcon from "../../assets/icons/close.png";
import itemImg from "./../../assets/icons/Item.png";
import WithdrawModalContent from "./Component/DialougeContent.jsx";
import BankDetailsSelectionModal from "./Component/BankDetailsSelectionModal.tsx";
import LoadingView from "../components/LoadingView/LoadingView.js";
import TransactionHead from "./Component/TransactionHead.js";
import { useLocation } from "react-router-dom";
import Player from "../../TestSound.js";
import FilterPanel from "./Component/FilterBar/FilterPanel.js";

const OrderHistoryLog = () => {
  const [restaurantId, setRestaurantId] = useState<string>("");
  const [amountData, setAmountData] = useState([]);
  const [loading, setLoading] = useState<boolean>(false);
  const [open, setOpen] = useState<boolean>(false);
  const [TableData, setTableData] = useState([]);
  const [TableDataAll, setTableDataAll] = useState([]);
  const [restaurantSelected, setRestaurantSelected] = useState(false);
  const [withdrawTypeSelected, setwithdrawTypeSelected] = useState(false);
  const handleOpen = () => setOpenWithDrawModal(true);
  const handleClose = () => setOpenWithDrawModal(false);
  const api = process.env.REACT_APP_SECRET;
  const [TotalCredit, setTotalCredit] = useState(0);
  const [totalCardValue, setTotalCardValue] = useState({});
  const [totalWithdrawableAmount, setTotalWithdrawableAmount] = useState({});
  const [totalPendingAmount, setTotalPendingAmount] = useState({});
  const [refreshData, setRefreshData] = useState(false);
  const [selectedWithdrawType, setSelectedWithdrawType] = useState(null);
  const [selectedOrders, setSelectedOrders] = useState([]);
  const [calculatedTotal, setCalculatedTotal] = useState({});
  const [selectedRestaurant, setSelectedRestaurant] = useState({});
  const [searchValue, setSearchValue] = useState("");
  const [withdrawEvent, setWithdrawEvent] = useState(false);
  const [activeTab, setActionTab] = useState("Transaction");
  const [restaurants, setRestaurant] = useState([]);
  const [selectedchildRestaurant] = useState(
    JSON.parse(localStorage.getItem("restaurant"))
  );
  const [sidebarCollapse, setSidebarCollapse] = useState(true);
  const location = useLocation();
  const [dataFactory, setDataFactory] = useState([]);

  const handleRestaurantSelect = (props) => {
    console.log(props);
    var obj = {
      id: props.id,
      name: props.name,
    };
    localStorage.setItem("restaurant", JSON.stringify(obj));
    localStorage.setItem("restaurantChanged", "newRestaurantSeelected");

    // Broadcast the change to other tabs
    const broadcastChannel = new BroadcastChannel("storage_change_channel");
    broadcastChannel.postMessage("restaurantChanged");

    window.dispatchEvent(new Event("storage"));
    handleClose();
  };

  const loadDataForRestaurant = async () => {
    const token = localStorage.getItem("gotasteadmintoken");
    var decodedData = {};

    if (token != null) {
      try {
        decodedData = jwt_decode(token);

        var obj = {
          id: decodedData.UserId,
          title: decodedData.UserName,
        };
      } catch (error) {}
    }

    const restaurant = JSON.parse(localStorage.getItem("parentrestaurant"));

    await axios
      .get(
        api +
          "/api/Restaurant/getrestaurantdetailsbyidfortable/" +
          "2e528a48-2121-48bd-97d4-b6ec8865bff2" +
          "/" +
          restaurant.id
      )
      .then((response) => {
        var list = [];
        response.data.map((dt, i) => {
          var obj = {
            id: dt.id,
            name: dt.name,
            address: dt.addressLine1,
            PhoneNumber: dt.phoneNumber,
            Email: dt.emailAddress,
          };
          list.push(obj);
        });

        setRestaurant(list);
      });
  };

  useEffect(() => {
    const token = localStorage.getItem("gotasteadmintoken");

    const parentrestaurant = JSON.parse(
      localStorage.getItem("parentrestaurant")
    );

    var decodedData = {};

    if (token != null) {
      try {
        decodedData = jwt_decode(token);
        console.log(decodedData);
        setTokenData(decodedData);
      } catch (error) {}
    }

    loadDataForRestaurant();
  }, []);

  const handleClickOpen = () => {
    setOpen(true);
  };
  interface Transaction {
    transactionId: string;
    dateTime: string;
    totalAmount: number;
    transactionAmount: number;
    remainingBalance: number;
  }

  useEffect(() => {
    const restaurant = localStorage.getItem("parentrestaurant");
    if (restaurant) {
      setRestaurantId(JSON.parse(restaurant).id);
    }
  }, []);

  // useEffect(() => {
  //   (async () => {
  //     try {
  //       setLoading(true);
  //       const response = await axios.get(
  //         `${process.env.REACT_APP_SECRET}/api/Order/GetOrderHistoryByRestaurant?restaurentId=${restaurantId}`
  //       );
  //       console.log("restaurant id local: ", response.data);
  //       setAmountData(response.data);
  //     } catch (error) {
  //       console.log(error);
  //     } finally {
  //       setLoading(false);
  //     }
  //   })();
  // }, [restaurantId]);

  const rows = [
    {
      orderId: "01",
      transaction: "Withdraw",
      dateTime: "08-02-25",
      totalAmount: 100,
      totalRefunded: 0,
      totalServiceCharge: 10,
      totalTips: 20,
      totalCredit: 0,
      totalPlatformFees: 0.5,
      totalProcessingFees: 0.6,
      totalCaptureFees: 0.05,
      totalAuthenticationFees: 0.07,
      totalTrnsactionFees: 1.22,
      // withdrawed: -10,
      totalWithdrawableAmount: 38.78,
      foodItems: [
        {
          withdrawType: "Full",
          transactionId: "577445774",
          dateTime: "08-02-25",
          totalWithdrawnAmount: -38.78,
          remainingWithdrableBalance: 0,
          matchedRefundedOrder: "03", // order number from which this money was taken.
          matchedRefundedAmount: 30.0,
          paidToBankAccount: 8.78,
        },
      ],
    },
    {
      orderId: "01",
      transaction: "Refund",
      dateTime: "07-02-25",
      totalAmount: 100,
      totalRefunded: -50,
      totalServiceCharge: 10,
      totalTips: 20,
      totalCredit: 0,
      totalPlatformFees: 0.5,
      totalProcessingFees: 0.6,
      totalCaptureFees: 0.05,
      totalAuthenticationFees: 0.07,
      totalTrnsactionFees: 1.22,
      // withdrawed: 0,
      totalWithdrawableAmount: 48.78,
      foodItems: [
        {
          foodItemName: "Salmon Burger",
          transactionId: "68899686",
          dateTime: "07-02-25",
          refunded: -50,
          matchOrder: "2, 3",
          matchAmount: 12.0,
        },
      ],
    },
    {
      orderId: "01",
      transaction: "Transaction",
      dateTime: "06-02-25",
      totalAmount: 100,
      totalRefunded: 0,
      totalServiceCharge: 10,
      totalTips: 20,
      totalCredit: 0,
      totalPlatformFees: 0.5,
      totalProcessingFees: 0.6,
      totalCaptureFees: 0.05,
      totalAuthenticationFees: 0.07,
      totalTrnsactionFees: 1.22,
      // withdrawed: 0,
      totalWithdrawableAmount: 98.78,
      foodItems: [
        {
          foodItemName: "Salmon burger",
          totalServiceCharge: 10,
          totalTips: 20,
          totalCredit: 0,
          foodItemBasePrice: 20,
          totalAmount: 98.78,
          addons: [
            {
              addonName: "addon name",
              addOnVatAmount: 1,
              addOnSdAmount: 8,
              addOnQuantity: 2,
              addOnBasePrice: 4,
              addOnTotalPrice: 11,
              options: [
                {
                  optionName: "option name",
                  optionVatAmount: 1.1,
                  optionSdAmount: 1.23,
                  optionQuantity: 4,
                  optionBasePrice: 2,
                  optionTotalPrice: 44,
                  subOptions: [
                    {
                      subOptionName: "sub option name",
                      subOptionVatAmount: 4,
                      subOptionSdAmount: 1,
                      subOptionQuantity: 3,
                      subOptionBasePrice: 4,
                      subOptoinTotalPrice: 22,
                    },
                  ],
                },
              ],
            },
          ],
        },
        {
          foodItemName: "Cheese Burger",
          totalServiceCharge: 10,
          totalTips: 20,
          totalCredit: 0,
          foodItemBasePrice: 20,
          totalAmount: 98.78,
          addons: [],
        },
      ],
    },
  ];

  const transactions: Transaction[] = [
    {
      transactionId: "577445774",
      dateTime: "09-02-25",
      totalAmount: 38.78,
      transactionAmount: -38.78,
      remainingBalance: 0,
    },
    {
      transactionId: "43833428",
      dateTime: "08-02-25",
      totalAmount: 48.78,
      transactionAmount: -10,
      remainingBalance: 38.78,
    },
    {
      transactionId: "68899686",
      dateTime: "07-02-25",
      totalAmount: 98.78,
      transactionAmount: -50,
      remainingBalance: 48.78,
    },
    {
      transactionId: "53893483",
      dateTime: "06-02-25",
      totalAmount: 98.78,
      transactionAmount: 0,
      remainingBalance: 98.78,
    },
  ];

  const [openWithDrawModal, setOpenWithDrawModal] = useState(false);

  // const AmountCardClicked = () => {
  //     setOpenWithDrawModal(!openWithDrawModal);
  // }

  const AmountCardClicked = (title: string) => {
    if (
      title === "Total Amount" ||
      title === "Total Service Ch." ||
      title === "Total Tips"
    ) {
      setOpenWithDrawModal(true);
    }
  };

  const loadOrderHistoryLogData = async () => {
    setLoading(true);
    let restaurant = localStorage.getItem("restaurant");
    let restaurantObj = restaurant ? JSON.parse(restaurant) : null;
    console.log("restaurantObj", restaurantObj);
    if (restaurantObj?.id) {
      await axios
        .get(
          `${process.env.REACT_APP_SECRET}/api/OrderHistoryLog?restaurantId=${restaurantObj.id}`
        )
        .then((response) => {
          setDataFactory(response.data);
          setTableData(response.data);
          setTableDataAll(response.data);
          setLoading(false);
        })
        .catch((error) => {
          setLoading(false);
          console.error("Error fetching order history:", error);
        });
    }
  };

  useEffect(() => {
    setTimeout(() => {
      loadOrderHistoryLogData();
    }, 200);
  }, [refreshData, withdrawEvent, location.key, location]);

  const GetTotalCreditByRestaurantId = async (restaurantId) => {
    try {
      const response = await axios.get(
        `${process.env.REACT_APP_SECRET}/api/OrderHistoryLog/GetTotalCreditByRestaurantId/${restaurantId}`
      );
      if (response !== null) {
        setTotalCredit(response.data);
      }
    } catch (error) {
      console.log("Error fetching total credit:", error);
    }
  };

  useEffect(() => {
    const localSelectedRestaurant = localStorage.getItem("restaurant");

    if (localSelectedRestaurant) {
      const parsedRestaurant = JSON.parse(localSelectedRestaurant);
      const getTotalCredit = async () => {
        await GetTotalCreditByRestaurantId(parsedRestaurant.id);
      };

      getTotalCredit();
    }
  }, []);

  const GetTotalCalculatedAmount = async () => {
    try {
      const restaurant = JSON.parse(localStorage.getItem("restaurant"));
      await axios
        .get(
          `${process.env.REACT_APP_SECRET}/api/OrderHistoryLog/GetTotalAmount?restaurantId=${restaurant?.id}`
        )
        .then((response) => {
          setTotalCardValue(response?.data?.totalAmount);
          setTotalPendingAmount(response?.data?.totalPendingAmount);
          setTotalWithdrawableAmount(response?.data?.totalWithdrawableAmount);
        });
    } catch (exception) {
      console.log(exception);
    }
  };

  useEffect(() => {
    if (TableData && TableData.length > 0) {
      GetTotalCalculatedAmount();
    }
  }, [TableData]);

  const SelectedWithdrawTypes = (data) => {
    setSelectedWithdrawType(data);
  };

  const GetSelectedOrders = (data) => {
    setSelectedOrders(data);
  };

  const getCalculatedTotal = (data) => {
    setCalculatedTotal(data);
  };

  const getSelectedRestaurant = (data) => {
    setSelectedRestaurant(data);
  };

  const handleInputChange = (e) => {
    setSearchValue(e.target.value);
  };

  const searchingOnOrders = () => {
    if (searchValue !== "") {
      const filteredData = TableDataAll.filter((item) =>
        item.id.toLowerCase().includes(searchValue.toLowerCase())
      );

      setTableData(filteredData);
    } else {
      setTableData(TableDataAll);
    }
  };

  const withdrawOnClick = () => {
    setSelectedOrders([]);
    setWithdrawEvent(!withdrawEvent);
  };

  const switchTabContent = (usedIN) => {
    setActionTab(usedIN);
  };

  useEffect(() => {
    document.title = activeTab + " | Order History Log";
  }, [activeTab]);

  // Withdraw Processing
  const [needToAdjust, setNeedToAdjust] = useState([]);
  const NeedToAdjust = (data) => {
    setNeedToAdjust(data);
  };

  console.log(
    "RefundDetails",
    TableData.filter((item) => item.transactionStatus === "Refund")
  );

  const handleFilterChange = (filter) => {
    setLoading(true);
    console.log("Selected Filter:", filter);

    const { type, range, custom } = filter;

    // Always start from the full data
    let filteredData = [...dataFactory];

    console.log("Initial Data:", filteredData);

    if (type && type !== "All") {
      filteredData = filteredData.filter(
        (item) =>
          item.transactionStatus &&
          item.transactionStatus.toLowerCase() == type.toLowerCase()
      );
    }

    if (range && range !== "All") {
      const now = new Date();
      let startDate = null;
      let endDate = null;

      switch (range) {
        case "Today":
          startDate = new Date();
          startDate.setHours(0, 0, 0, 0);
          endDate = new Date();
          endDate.setHours(23, 59, 59, 999);
          break;

        case "This Week": {
          const current = new Date();
          const first = current.getDate() - current.getDay();
          startDate = new Date(current.setDate(first));
          startDate.setHours(0, 0, 0, 0);
          endDate = new Date(startDate);
          endDate.setDate(startDate.getDate() + 6);
          endDate.setHours(23, 59, 59, 999);
          break;
        }

        case "This Month":
          startDate = new Date(now.getFullYear(), now.getMonth(), 1);
          endDate = new Date(
            now.getFullYear(),
            now.getMonth() + 1,
            0,
            23,
            59,
            59,
            999
          );
          break;

        case "This Year":
          startDate = new Date(now.getFullYear(), 0, 1);
          endDate = new Date(now.getFullYear(), 11, 31, 23, 59, 59, 999);
          break;

        case "Custom":
          if (custom?.from && custom?.to) {
            startDate = new Date(custom.from);
            endDate = new Date(custom.to);
            endDate.setHours(23, 59, 59, 999);
          }
          break;

        default:
          break;
      }

      if (startDate && endDate) {
        filteredData = filteredData.filter((item) => {
          const date = new Date(item.orderPlacementDateTime || item.createdAt);
          return !isNaN(date) && date >= startDate && date <= endDate;
        });
      }
    }

    // --- 3️⃣ Sort by date DESC ---
    filteredData.sort((a, b) => {
      const dateA = new Date(a.paymentDate || a.createdAt);
      const dateB = new Date(b.paymentDate || b.createdAt);
      return dateB - dateA;
    });

    // --- 4️⃣ Update Table ---
    console.log("Filtered & Sorted Data:", filteredData);
    setTableData(filteredData);
    setLoading(false);
  };

  return (
    <div>
      <TopHeader />
      <div className="sidebarOpen">
        {!sidebarCollapse && (
          <div className="d-flex gap-2 align-items-center">
            <img
              src={leftSidebarArrow}
              style={{ width: "20px", height: "50px", rotate: "180deg" }}
              onClick={() => setSidebarCollapse(!sidebarCollapse)}
            />
          </div>
        )}
      </div>

      <Grid container className="d-flex flex-row ">
        {/* Sidebar */}
        <Grid
          item
          xs={2}
          style={{
            display: !sidebarCollapse ? "none" : "block",
            position: "relative",
          }}
        >
          {/* ---Restaurant Selection--- */}
          <div className="d-flex side-bar-container" style={{ width: "100%" }}>
            <div style={{ width: "100%" }}>
              <Box
                sx={{
                  maxWidth: "95%",
                  width: "100%",
                  marginTop: "1rem",
                  marginBottom: "1rem",
                  marginLeft: ".5rem",
                }}
              >
                <FormControl fullWidth>
                  <InputLabel id="demo-simple-select-label">
                    {selectedchildRestaurant.name}
                  </InputLabel>
                  <Select
                    labelId="demo-simple-select-label"
                    id="demo-simple-select"
                    style={{ marginLeft: "0px" }}
                    // value={age}
                    label="Restaurant Name"
                    // onChange={handleChange}
                  >
                    {restaurants.map((dt, i) => {
                      return (
                        <MenuItem
                          style={{ background: "none" }}
                          onClick={() => {
                            handleRestaurantSelect(dt);
                          }}
                          selected={selectedchildRestaurant.name == dt.name}
                        >
                          {dt.name}
                        </MenuItem>
                      );
                    })}

                    {/* <MenuItem value={20}>Pot Kettle Black Manchester</MenuItem> */}
                  </Select>
                </FormControl>
              </Box>
            </div>
          </div>

          {/* --Transaction--Invoice--Refund--left arrow--- */}
          <div className="p-2 d-flex flex-column gap-2 listContainer">
            {/* -- Transaction Tab -- */}
            <div
              className={`menuItemContainer ${
                activeTab === "Transaction" ? "active" : ""
              }`}
              onClick={() => switchTabContent("Transaction")}
            >
              <img className="sidebarIcon" src={mobilePayment} />
              <Typography>Transaction Log</Typography>
            </div>

            {/* -- InVoice Tab -- */}
            {/* <div
              className={`menuItemContainer ${activeTab === "Invoice" ? 'active' : ''}`}
              onClick={() => switchTabContent("Invoice")}
            >
              <img className="sidebarIcon" src={bill} />
              <Typography>Invoice Log</Typography>
            </div> */}

            {/* -- Refund Tab -- */}
            {/* <div
              className={`menuItemContainer ${activeTab === "Refund" ? 'active' : ''}`}
              onClick={() => switchTabContent("Refund")}
            >
              <img className="sidebarIcon" src={refund} />
              <Typography>Refund Log</Typography>
            </div> */}

            {/* --Left Arrow-- */}
            <div className="sidebarToolbar">
              {sidebarCollapse && (
                <img
                  src={leftSidebarArrow}
                  style={{ cursor: "pointer", height: "50px", width: "20px" }}
                  onClick={() => setSidebarCollapse(!sidebarCollapse)}
                />
              )}
            </div>
          </div>
        </Grid>

        {/* Right Side Content */}
        <Grid item xs={!sidebarCollapse ? 12 : 10}>
          {/* Cards */}
          <div
            className="amount-card-container"
            style={{ justifyContent: !sidebarCollapse ? "center" : "" }}
          >
            <span onClick={() => AmountCardClicked("Total Amount")}>
              <AmountCard
                title={"Total Amount"}
                amount={
                  "£ " +
                  (totalCardValue.totalAmount !== undefined
                    ? totalCardValue?.totalAmount?.toFixed(2)
                    : 0)
                }
                pendingAmount={
                  "£ " +
                  (totalPendingAmount.totalAmount !== undefined
                    ? totalPendingAmount?.totalAmount?.toFixed(2)
                    : 0)
                }
                withdrawableAmount={
                  "£ " +
                  (totalWithdrawableAmount.totalAmount !== undefined
                    ? totalWithdrawableAmount?.totalAmount?.toFixed(2)
                    : 0)
                }
                withdrawn={TotalCredit?.totalWithdrawnAmount?.toFixed(2)}
                icon={gross}
                colorCode={"#FF8F00"}
                usedIn="Amount"
              />
            </span>

            <AmountCard
              title={"Total Credit"}
              usedIn={"Credit"}
              amount={
                "£ " +
                (totalCardValue?.totalCredit !== undefined
                  ? totalCardValue?.totalCredit?.toFixed(2)
                  : 0)
              }
              pendingAmount={
                "£ " +
                (totalPendingAmount?.totalCredit !== undefined
                  ? totalPendingAmount?.totalCredit?.toFixed(2)
                  : 0)
              }
              withdrawableAmount={
                "£ " +
                (totalWithdrawableAmount?.totalCredit !== undefined
                  ? totalWithdrawableAmount?.totalCredit?.toFixed(2)
                  : 0)
              }
              withdrawn={"£ 150"}
              icon={credit}
              colorCode={"#42A5F5"}
            />

            <div onClick={() => AmountCardClicked("Total Service Ch.")}>
              <AmountCard
                title={"Total Service Ch."}
                amount={
                  "£ " +
                  (totalCardValue.totalServiceCharge !== undefined
                    ? totalCardValue.totalServiceCharge?.toFixed(2)
                    : 0)
                }
                pendingAmount={
                  "£ " +
                  (totalPendingAmount.totalServiceCharge !== undefined
                    ? totalPendingAmount.totalServiceCharge?.toFixed(2)
                    : 0)
                }
                withdrawableAmount={
                  " £ " +
                  (totalWithdrawableAmount.totalServiceCharge !== undefined
                    ? totalWithdrawableAmount.totalServiceCharge?.toFixed(2)
                    : 0)
                }
                withdrawn={TotalCredit?.totalWithdrawnServiceCharge?.toFixed(2)}
                icon={service}
                colorCode={"#26A69A"}
                usedIn="Service Ch."
              />
            </div>
            <div onClick={() => AmountCardClicked("Total Tips")}>
              <AmountCard
                title={"Total Tips"}
                amount={
                  "£ " +
                  (totalCardValue?.totalTips !== undefined
                    ? totalCardValue?.totalTips?.toFixed(2)
                    : 0)
                }
                pendingAmount={
                  "£ " +
                  (totalPendingAmount.totalTips !== undefined
                    ? totalPendingAmount.totalTips?.toFixed(2)
                    : 0)
                }
                withdrawableAmount={
                  "£ " +
                  (totalWithdrawableAmount.totalTips !== undefined
                    ? totalWithdrawableAmount.totalTips?.toFixed(2)
                    : 0)
                }
                withdrawn={TotalCredit?.totalWithdrawnTips?.toFixed(2)}
                icon={tip}
                colorCode={"rgb(61 130 16 / 63%"}
                usedIn="Tips"
              />
            </div>
          </div>
          <FilterPanel onFilterChange={handleFilterChange} />
          {/* ---Transaction tab content--- */}
          <div
            style={{
              display: activeTab === "Transaction" ? "block" : "none",
            }}
          >
            {/* Search Fields */}
            {/* <div className="orderHistoryLogSearchBox">
              <input type="text" placeholder="Search by id" onChange={handleInputChange} value={searchValue} />
              <button onClick={searchingOnOrders}>Search</button>
            </div> */}

            {/* Data Table */}
            {loading ? (
              <LoadingView open={true} close={() => setLoading(false)} />
            ) : (
              <TableContainer
                component={Paper}
                className="order-history-table"
                sx={{ maxHeight: "100vh" }}
              >
                <Table
                  aria-label="sticky table"
                  sx={{ tableLayout: "fixed" }}
                  className="order-table"
                  stickyHeader
                >
                  <TransactionHead />
                  <TableBody>
                    {TableData.length === 0 ? (
                      <TableRow>
                        <TableCell colSpan={10} align="center">
                          No transactions found.
                        </TableCell>
                      </TableRow>
                    ) : (
                      TableData.sort(
                        (a, b) =>
                          new Date(b.transactionDateTime) -
                          new Date(a.transactionDateTime)
                      ).map((row, i) => (
                        <OrderRow
                          key={i} // ✅ make sure id is unique
                          row={row}
                          transactions={transactions}
                          TotalData={TableData}
                          SetRefreshData={setRefreshData}
                          RefreshData={refreshData}
                        />
                      ))
                    )}
                  </TableBody>
                </Table>
              </TableContainer>
            )}
          </div>

          {/* ---Invoice tab content--- */}
          <div style={{ display: activeTab === "Invoice" ? "block" : "none" }}>
            <h4 className="LogsTabContentHeading">Invoice Log</h4>

            {/* Data Table */}
            {loading ? (
              <LoadingView
                open={true}
                close={() => {
                  setLoading(false);
                }}
              />
            ) : (
              <TableContainer component={Paper} className="order-history-table">
                <Table aria-label="collapsible table" className="order-table">
                  <TransactionHead />
                  <TableBody>
                    {TableData.sort(
                      (a, b) =>
                        new Date(b.transactionDateTime) -
                        new Date(a.transactionDateTime)
                    ).map((row) => (
                      <OrderRow
                        // key={row.orderId}
                        key={row.id}
                        row={row}
                        transactions={transactions}
                        TotalData={TableData}
                        SetRefreshData={setRefreshData}
                        RefreshData={refreshData}
                      />
                    ))}
                  </TableBody>
                </Table>
              </TableContainer>
            )}
          </div>

          {/* -- Refund tab content -- */}
          <div style={{ display: activeTab === "Refund" ? "block" : "none" }}>
            {/* Data Table */}
            {loading ? (
              <LoadingView
                open={true}
                close={() => {
                  setLoading(false);
                }}
              />
            ) : (
              <TableContainer component={Paper} className="order-history-table">
                <Table aria-label="collapsible table" className="order-table">
                  <TransactionHead />
                  <TableBody>
                    {TableData.sort(
                      (a, b) =>
                        new Date(b.transactionDateTime) -
                        new Date(a.transactionDateTime)
                    )
                      .filter((trans) => trans.transactionStatus === "Refund")
                      .map((row) => (
                        <OrderRow
                          // key={row.orderId}
                          key={row.id}
                          row={row}
                          transactions={transactions}
                          TotalData={TableData}
                          SetRefreshData={setRefreshData}
                          RefreshData={refreshData}
                        />
                      ))}
                  </TableBody>
                </Table>
              </TableContainer>
            )}
          </div>
        </Grid>
      </Grid>

      {/* WithDraw Modal */}
      <React.Fragment>
        <Dialog
          fullWidth={true}
          maxWidth={"xl"}
          open={openWithDrawModal}
          onClose={handleClose}
        >
          {/* Header */}
          <Grid
            container
            className="d-flex space-between align-items-center"
            style={{ backgroundColor: "rgba(86, 89, 91, 0.69)" }}
          >
            {/* Logo & header - dialouge header */}
            <Grid item xs={6}>
              <DialogTitle>
                <div className="d-flex" style={{ gap: "8px" }}>
                  {/* Logo */}
                  <div>
                    <img src={itemImg} style={{ width: "1.8rem" }} alt="" />
                  </div>
                  {/* Header */}
                  <span
                    style={{
                      // color: "#2a7fd4"
                      color: "white",
                    }}
                  >
                    Widthdraw Modal
                  </span>
                </div>
              </DialogTitle>
            </Grid>
            {/* Close button - header */}
            <Grid item xs={6}>
              <DialogActions>
                <Button onClick={() => setOpenWithDrawModal(false)}>
                  <img
                    src={closeIcon}
                    alt="Close"
                    style={{ width: "1.2rem" }}
                  />
                </Button>
              </DialogActions>
            </Grid>
          </Grid>

          <DialogContent style={{ backgroundColor: "#f3f0f3" }}>
            <WithdrawModalContent
              setRestaurantSelected={setRestaurantSelected}
              getSelectedWithdrawTypes={SelectedWithdrawTypes}
              getSelectedOrders={GetSelectedOrders}
              GetCalculatedTotal={getCalculatedTotal}
              GetSelectedRestaurant={getSelectedRestaurant}
              withdrawOnClick={withdrawEvent}
              needToAdjust={NeedToAdjust}
            />
          </DialogContent>

          {/* Footer */}
          <DialogActions style={{ marginRight: "10px" }}>
            <Button
              onClick={handleClickOpen}
              color="primary"
              variant="contained"
              disabled={
                selectedOrders?.length === 0 || selectedWithdrawType === null
              }
            >
              Next
            </Button>
            <Button onClick={handleClose} color="secondary">
              Close
            </Button>
          </DialogActions>
        </Dialog>

        <BankDetailsSelectionModal
          open={open}
          setOpen={setOpen}
          selectedOrders={selectedOrders}
          calculatedTotal={calculatedTotal}
          selectedRestaurant={selectedRestaurant}
          selectedWithdrawTypes={selectedWithdrawType}
          withdrawSuccessfull={withdrawOnClick}
          NeedToAdjustForPayload={needToAdjust}
        />
      </React.Fragment>
    </div>
  );
};

export default OrderHistoryLog;
